<template>
  <div class="account-view">
    <div class="account-view__content" v-if="isRequestingResetLink">
      <div class="account-view__section">
        <div class="mb-4 login-form">
          <h1 class="title is-3 has-text-grey">Passwort zurücksetzen</h1>
          <transition name="fade" v-if="isPasswordResetLinkSent && !processing">
            <p class="has-text-success is-size-4" v-if="passwordResetLinkError===''">
              Wenn ein Konto zu dieser E-Mail Adresse existiert, wurde ein Link zum Zurücksetzen Ihres Passworts an Sie versendet.
            </p>
            <p class="has-text-danger is-size-4" v-else-if="passwordResetLinkError === 'Active code found'">
              Ein Link zum Zurücksetzen Ihres Passworts wurde bereits versendet
              Sie können nur alle 24 Stunden einen neuen Link anfordern.
            </p>
            <p class="has-text-danger is-size-4" v-else>
              Hier ist ein Fehler aufgetreten.<br><br>
              Eventuell ist der verwendete Nutzername nicht korrekt.<br><br>
              Versuchen Sie einen anderen Nutzernamen oder versuchen Sie es später noch einmal.
            </p>
          </transition>
        </div>
      </div>
      <div class="account-view__section has-background-grey-lighter">
        <form class="login-form" @submit.prevent="">
          <div class="columns is-multiline is-right">
            <div class="column is-full">
              <div class="field">
                <label class="label is-uppercase mt-3 ml-3">{{$t('login.inputLabels.userNameOrEmail')}}</label>
                <div class="control">
                  <input v-model="email" class="input" type="text"
                         :placeholder="$t('login.inputLabels.userNameOrEmail')">
                </div>
              </div>
            </div>
            <!-- <div class="column is-full">
                 <div class="field">
                     <label class="label is-uppercase mt-3 ml-3">E-Mail</label>
                     <div class="control">
                         <input v-model="email" class="input" type="email"
                                placeholder="E-Mail">
                     </div>
                 </div>
             </div>-->
            <div class="column is-full login-form__actions">

              <button @click="sendPasswordResetLink"
                      :disabled="email.trim() === '' && !passwordResetError"
                      :class="{'is-loading': processing}"
                      class="button is-primary-dark px-6">{{ buttonText }}
              </button>

            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="account-view__content" v-else-if="passwordResetCode">
      <div class="account-view__section">
        <div class="mb-4 login-form">
          <h1 class="title is-3 has-text-grey">{{ $t('login.mainActions.resetPassword') }}</h1>
          <h2 class="title is-5 has-text-grey is-uppercase">Bitte legen Sie ein neues Passwort fest.</h2>
          <p class="has-text-success is-size-4 status-message">
            {{ passwordMessage }}
          </p>
          <p class="has-text-danger is-size-4" v-if="passwordResetError">
            Hier scheint ein Fehler aufgetreten zu sein.
            Der Link zum Zurücksetzen Ihres Passworts wurde bereits benutzt oder ist abgelaufen.
          </p>
        </div>
      </div>

      <div class="account-view__section has-background-grey-lighter">
        <div class="login-form">
          <div class="columns is-multiline is-right">

            <div class="column is-full">
              <div class="field">
                <label class="label is-uppercase mt-3 ml-3">Neues Passwort</label>
                <div class="control">
                  <input v-model="newPassword" class="input" type="password"
                         pattern="^[\w+\s+0-9]{8,}$"
                         placeholder="Passwort">
                </div>
              </div>
            </div>
            <div class="column is-full">
              <div class="field">
                <label class="label is-uppercase mt-3 ml-3">Passwort wiederholen</label>
                <div class="control">
                  <input v-model="passwordRepeat" class="input" type="password" :pattern="newPassword"
                         placeholder="Passwort">
                </div>
              </div>
            </div>
            <div class="column is-full login-form__actions">

              <button @click="resetPassword"
                      :disabled="!(newPassword.trim().length > 7 && newPassword === passwordRepeat)"
                      :class="{'is-loading': passwordResetPending}"
                      class="button is-primary-dark px-6">Passwort zurücksetzen
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import SvgIcon from "../svg/SvgIcon";
import {eventBus} from "../../events/event-bus";
import i18n from "../../i18n";

export default {
  name: "PasswordReset",
  components: {SvgIcon},
  data() {
    return {
      email: "",
      password: "",
      newPassword: "",
      passwordRepeat: "",
      processing: false,
      loginFailed: false,
      isPasswordResetLinkSent: false,
      passwordResetLinkError: '',
      buttonText: "Passwort zurücksetzen",
      passwordButtonText: "Passwort zurücksetzen",
      passwordResetPending: false,
      passwordResetCode: '',
      passwordResetError: false,
    }
  },
  computed: {
    isRequestingResetLink() {
      return !this.$route.params.resetId;
    },
    passwordMessage() {
      if (this.passwordResetPending) {
        return "Wird zurückgesetzt..."
      }
      if (this.passwordResetSuccessful) {
        return "Passwort wurde zurückgesetzt."
      }
      if (this.newPassword.length === 0) {
        return ""
      } else if (this.newPassword.length < 8)
        return "Mindestens 8 Zeichen."
      else {
        if (this.passwordRepeat.length === 0) {
          return ""
        } else {
          if (this.passwordRepeat.length >= this.newPassword.length) {
            if (this.passwordRepeat !== this.newPassword) {
              return "Passwörter stimmen nicht überein."
            } else {
              return ""
            }
          }
        }
      }
      return ""
    }
  },
  methods: {
    sendPasswordResetLink() {
      this.processing = true;
      this.$store.dispatch('sendPasswordResetLink', {email: this.email}).then(() => {
        this.processing = false;
        this.isPasswordResetLinkSent = true;
        this.passwordResetSuccessful = true;
      }).catch((errorMessage) => {
        this.isPasswordResetLinkSent = true;
        this.processing = false;
        this.passwordResetPending = false;
        this.passwordResetSuccessful = false;
        this.passwordResetError = true;
        this.newPassword = "";
        this.passwordRepeat = "";
        this.passwordResetLinkError = errorMessage;

      })
    },
    resetPassword() {
      this.passwordResetPending = true;
      this.$store.dispatch('resetPassword', {
        resetData:
            {
              uuid: this.$route.params.resetId,
             password: this.newPassword,
            }
      }).then(() => {
        eventBus.notification({
          type: 'success',
          header: i18n.t('login.messages.passwordResetSuccess.header'),
          body: i18n.t('login.messages.passwordResetSuccess.body')
        })
        setTimeout(() => {
          this.$router.push('/login');
        }, 3000)
        this.processing = false;
        this.passwordResetPending = false;
        this.passwordResetSuccessful = true;
        this.newPassword = "";
        this.passwordRepeat = ""
      }).catch(() => {
        this.processing = false;
        this.passwordResetPending = false;
        this.passwordResetSuccessful = false;
        this.passwordResetError = true;
        this.newPassword = "";
        this.passwordRepeat = ""
      })
    },
    fetchCMSData() {
      this.$store.dispatch('fetchCMSPage', {urlSlug: "/"});
    },
  },
  created() {
    this.fetchCMSData();
  },
  mounted() {
    this.passwordResetCode = this.$route.params.resetId;
  }
}
</script>

<style scoped>

</style>